import { useMemo } from 'react';

import { doc, DocumentReference } from 'firebase/firestore';

import { useDocument } from 'react-firebase-hooks/firestore';

import { useAuth } from '../contextProviders/AuthProvider';
import { firestore } from '../firebase';
import { USGA_COURSE_DRAFT_COLLECTION } from '../types/UsgaCourseSearch';

import type { UsgaCourseDraft } from '../types/UsgaCourseSearch';

/**
 * God only: one USGA course's draft (usgaCourseDraft/{usgaCourseId}) — its details and tee sets as
 * read by the server. `exists` is false once loading finishes without a doc, so the caller knows
 * to request one.
 */
export default function useUsgaCourseDraft(usgaCourseId: string | null) {
  const { isGod } = useAuth();
  const ref = useMemo(
    () => (isGod && usgaCourseId
      ? doc(firestore, USGA_COURSE_DRAFT_COLLECTION, usgaCourseId) as DocumentReference<UsgaCourseDraft>
      : null),
    [isGod, usgaCourseId],
  );
  const [snapshot, isLoading, error] = useDocument<UsgaCourseDraft>(ref);
  return {
    draft: snapshot?.data() ?? null,
    exists: snapshot ? snapshot.exists() : null,
    isLoading,
    error,
  };
}
